import React, { useState, useEffect } from 'react';
import presetApi from '@services/presetApi.jsx';
import ResourceUploadField from '@components/common/ResourceUploadField.jsx';

const PresetPrintModeSetting = ({ preset }) => {
    const [isLoading, setIsLoading] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const presetId = searchParams.get('presetId');
    const [presetPrintWaitingPage, setPresetPrintWaitingPage] = useState(null);

    // 폼 데이터 상태
    const [formData, setFormData] = useState({
        adVideoResourceId: null,
        additionalOptions: null,
        isActive: true
    });

    // 페이지 데이터 로드
    useEffect(() => {
        loadPrintWaitingPageData();
    }, [presetId]);

    // 인쇄 대기 페이지 데이터 로드
    const loadPrintWaitingPageData = async () => {
        try {
            setIsLoading(true);
            const printWaitingPage = await presetApi.getPrintWaitingPage(presetId);
            
            setPresetPrintWaitingPage(printWaitingPage);
            
            setFormData({
                adVideoResourceId: printWaitingPage.adVideoResourceId ?? null,
                additionalOptions: printWaitingPage.additionalOptions ?? null,
                isActive: printWaitingPage.isActive ?? true
            });
        } catch (error) {
            console.error('인쇄 대기 페이지 데이터 로드 실패:', error);
            // 에러 시 기본값 유지
        } finally {
            setIsLoading(false);
        }
    };

    // 광고영상 리소스 업로드 핸들러
    const handleAdVideoResourceUploaded = (resourceId) => {
        setFormData({
            ...formData,
            adVideoResourceId: resourceId
        });
    };

    // 저장 이벤트 리스너
    useEffect(() => {
        const eventName = `savePagePreset_print_mode`;

        const saveHandler = async (event) => {
            if (!preset?.id) {
                alert("프리셋 정보가 없습니다.");
                return;
            }

            try {
                setIsLoading(true);

                const dataToSave = {
                    presetId: event.detail.presetId,
                    adVideoResourceId: formData.adVideoResourceId,
                    additionalOptions: formData.additionalOptions,
                    isActive: formData.isActive
                };
                
                const response = await presetApi.savePrintWaitingPage(event.detail.presetId, dataToSave);
                console.log("인쇄 대기 페이지 저장 성공:", response);

            } catch (error) {
                console.error("인쇄 대기 페이지 저장 실패:", error);
                alert("인쇄 대기 페이지 저장 중 오류가 발생했습니다.");
            } finally {
                setIsLoading(false);
            }
        };

        document.addEventListener(eventName, saveHandler);

        return () => {
            document.removeEventListener(eventName, saveHandler);
        };
    }, [preset?.id, formData]);

    if (isLoading) {
        return <div className="preset-settings">로딩 중...</div>;
    }

    return (
        <div className="preset-settings">
            {/* 광고영상 섹션 */}
            <div className="settings-box">
                <h4 className="settings-title">광고영상</h4>
                <ResourceUploadField 
                    resourceId={formData.adVideoResourceId}
                    onResourceUploaded={handleAdVideoResourceUploaded}
                    acceptTypes="video/*"
                />
            </div>
        </div>
    );
};

export default PresetPrintModeSetting;
